// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"c2cd92b2","304":"c2cd92b2","843":"c2cd92b2","928":"c2cd92b2"}[chunkId] + ".chunk.css";
};